<template>
  <v-card elevation="4" class="rounded-sm">
    <v-card-title>
      <div class="text-subtitle-1 font-weight-bold">Tipos de incidencia</div>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col
            cols="12"
            md="2"
            v-for="incidencia in incidenciasFiltradas"
            :key="incidencia.idIncidencia"
            class="d-flex flex-column align-center"
          >
            <v-text-field
              v-model.number="incidencia.cantidad"
              type="number"
              :label="getIncidenciaTitle(incidencia.idIncidencia)"
              rounded
              filled
              color="secondary"
              background-color="primary"
              min="0"
              :readonly="readonly"
              class="mb-2"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { PERFILES } from '@/perfiles.js'

const INCIDENCIAS_VALIDAS = [1, 2, 3, 4, 5]

export default {
  props: {
    incidencias: {
      type: Array,
      required: true,
    },

    readonly: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    incidenciasFiltradas() {
      const unique = {}
      this.incidencias.forEach((inc) => {
        if (INCIDENCIAS_VALIDAS.includes(inc.idIncidencia)) {
          unique[inc.idIncidencia] = inc
        }
      })
      return INCIDENCIAS_VALIDAS.map((id) => unique[id] || { idIncidencia: id, cantidad: 0 })
    },
  },

  methods: {
    getIncidenciaTitle(idIncidencia) {
      const titles = {
        1: 'Faltas',
        2: 'Amonestaciones',
        3: 'Incapacidades',
        4: 'Permisos',
        5: 'Arresto',
      }
      return titles[idIncidencia] || ''
    },
  },
}
</script>

<style scoped>
.v-text-field {
  min-width: 120px;
}
</style>
